import { Outlet } from 'react-router-dom'
import PageTitle from '@/components/PageTitle'

export default function MetricsPage() {
  return (
    <>
      <PageTitle>Metrics</PageTitle>
      <Outlet />
    </>
  )
}
